import { useMutation } from "@tanstack/react-query";
import { createProgramByCreateProgramAdminRequest } from "../../../../../service/program";

const useCreateProgramByCreateProgramAdminRequest = () => {
    const mutation = useMutation({
        mutationFn: createProgramByCreateProgramAdminRequest,
    });

    return mutation;
}

export { useCreateProgramByCreateProgramAdminRequest }